import {
  AgentRotationRangeTypeEnum,
  LeadsClassTypesEnum,
} from "../../../Enums";

export const buildQueryBody = (formValues) => {
  const { addRotationForm, schemaSettingsForm } = formValues;
  const contactClasses = {
    normal: {
      contactClassId: 68,
      contactClassName: "Normal",
    },
    viip: {
      contactClassId: 70,
      contactClassName: "VVIP",
    },
    vip: {
      contactClassId: 69,
      contactClassName: "VIP",
    },
  };

  const currentContactClasses = [];
  const leadClasses = [];
  if (addRotationForm.vip) currentContactClasses.push(contactClasses.vip);
  if (addRotationForm.normal) currentContactClasses.push(contactClasses.normal);
  if (addRotationForm.viip) currentContactClasses.push(contactClasses.viip);
  if (addRotationForm.buyer) leadClasses.push(LeadsClassTypesEnum.buyer);
  if (addRotationForm.tenant) leadClasses.push(LeadsClassTypesEnum.tenant);
  return {
    rotationSchemeId: null,
    label: addRotationForm.label,
    order: String(addRotationForm.order),
    isForOwnerLeads: false,
    rotationPreferredLanguages: addRotationForm.rotationPreferredLanguages.map(
      ({ languageId }) => ({
        languageId,
      })
    ),
    rotationSchemeCountries: addRotationForm.rotationSchemeCountries,
    rotationSchemeCities: addRotationForm.rotationSchemeCities,
    rotationSchemeCommunities: addRotationForm.rotationSchemeCommunities,

    rotationSchemeDistricts: addRotationForm.rotationSchemeDistricts,
    rotationSchemeSubCommunities: addRotationForm.rotationSchemeSubCommunities,

    rotationSchemeUnitTypes: addRotationForm.rotationSchemeUnitTypes,
    rotationSchemeRanges: [
      {
        startValue: addRotationForm.priceRange[0],
        endValue: addRotationForm.priceRange[1],
        agentRotationRangeTypeId: AgentRotationRangeTypeEnum.PriceRange.key,
      },
      {
        startValue: addRotationForm.size[0],
        endValue: addRotationForm.size[1],
        agentRotationRangeTypeId: AgentRotationRangeTypeEnum.Size.key,
      },
      {
        startValue: addRotationForm.bathrooms[0],
        endValue: addRotationForm.bathrooms[1],
        agentRotationRangeTypeId: AgentRotationRangeTypeEnum.Bathroom.key,
      },
      {
        startValue: addRotationForm.bedrooms[0],
        endValue: addRotationForm.bedrooms[1],
        agentRotationRangeTypeId: AgentRotationRangeTypeEnum.Bedroom.key,
      },
    ],
    rotationSchemaContactCLasses: currentContactClasses,
    rotationSchemeMedias: addRotationForm.rotationSchemeMedias,

    rotationSchemaDeveloperIds: [],
    rotationSchemaReferredBys: addRotationForm.rotationSchemaReferredBys,

    rotationSchemeProperties: addRotationForm.rotationSchemeProperties,
    rotationSchemaLeadsType: leadClasses.map((item) => ({
      leadClass: item.key,
    })),
    rotationSchemaMethodOfContacts:
      addRotationForm.rotationSchemaMethodOfContacts.map((item) => ({
        ...item,
        methodOfContactId: item.lookupItemId,
      })),
    propertyCampaignIds: addRotationForm.propertyCampaignIds.map(
      (item) => item.propertyCampaignId
    ),
    rotationSchemeTeams: schemaSettingsForm.rotationSchemeTeams,
    rotationSchemeBranches: schemaSettingsForm.rotationSchemeBranches,
    sla: schemaSettingsForm.sla,
    isActive: addRotationForm.isActive,
    isBulk: addRotationForm.isBulk,
    rotationSchemeLeadDistributionType:
      schemaSettingsForm.rotationSchemeLeadDistributionType,
    isOverrideLeadCapacitySettingEnabled:
      schemaSettingsForm.isOverrideLeadCapacitySettingEnabled === "true",
    rotationSchemeCourses: schemaSettingsForm.rotationSchemeCourses,
  };
};
export const buildEditSchemaQueryBody = (formValues, id) => {
  const { addRotationForm, schemaSettingsForm } = formValues;
  const contactClasses = {
    normal: {
      contactClassId: 68,
      contactClassName: "Normal",
    },
    viip: {
      contactClassId: 70,
      contactClassName: "VVIP",
    },
    vip: {
      contactClassId: 69,
      contactClassName: "VIP",
    },
  };

  const currentContactClasses = [];
  const leadClasses = [];
  if (addRotationForm.vip) currentContactClasses.push(contactClasses.vip);
  if (addRotationForm.normal) currentContactClasses.push(contactClasses.normal);
  if (addRotationForm.viip) currentContactClasses.push(contactClasses.viip);
  if (addRotationForm.buyer) leadClasses.push(LeadsClassTypesEnum.buyer);
  if (addRotationForm.tenant) leadClasses.push(LeadsClassTypesEnum.tenant);
  return {
    rotationSchemeId: id,
    label: addRotationForm.label,
    order: String(addRotationForm.order),
    isForOwnerLeads: false,
    rotationPreferredLanguages: addRotationForm.rotationPreferredLanguages.map(
      ({ lookupsId, lookupItemName }) => ({
        languageName: lookupItemName,
        languageId: lookupsId,
      })
    ),
    rotationSchemeCountries: addRotationForm.rotationSchemeCountries.map(
      (item) => ({
        countryId: item.lookupsId,
        countryName: item.lookupItemName,
      })
    ),
    rotationSchemeCities: addRotationForm.rotationSchemeCities.map((item) => ({
      cityId: item.lookupsId,
      cityName: item.lookupItemName,
    })),
    rotationSchemeCommunities: addRotationForm.rotationSchemeCommunities.map(
      (item) => ({
        communityId: item.lookupsId,
        communityName: item.lookupItemName,
      })
    ),
    rotationSchemeDistricts: addRotationForm.rotationSchemeDistricts.map(
      (item) => ({
        districtId: item.lookupsId,
        districtName: item.lookupItemName,
      })
    ),
    rotationSchemeSubCommunities:
      addRotationForm.rotationSchemeSubCommunities.map((item) => ({
        subCommunityId: item.lookupsId,
        subCommunityName: item.lookupItemName,
      })),
    rotationSchemeUnitTypes: addRotationForm.rotationSchemeUnitTypes.map(
      (item) => ({
        unitTypeId: item.lookupsId,
        unitTypeName: item.lookupItemName,
      })
    ),
    rotationSchemeRanges: [
      {
        startValue: addRotationForm.priceRange[0],
        endValue: addRotationForm.priceRange[1],
        agentRotationRangeTypeId: AgentRotationRangeTypeEnum.PriceRange.key,
      },
      {
        startValue: addRotationForm.size[0],
        endValue: addRotationForm.size[1],
        agentRotationRangeTypeId: AgentRotationRangeTypeEnum.Size.key,
      },
      {
        startValue: addRotationForm.bathrooms[0],
        endValue: addRotationForm.bathrooms[1],
        agentRotationRangeTypeId: AgentRotationRangeTypeEnum.Bathroom.key,
      },
      {
        startValue: addRotationForm.bedrooms[0],
        endValue: addRotationForm.bedrooms[1],
        agentRotationRangeTypeId: AgentRotationRangeTypeEnum.Bedroom.key,
      },
    ],
    rotationSchemaContactCLasses: currentContactClasses,
    rotationSchemeMedias: addRotationForm.rotationSchemeMedias.map((item) => ({
      mediaName: item.mediaName,
      mediaNameId: item.mediaId === 0 ? null : item.mediaId,
      mediaDetailsName: item.mediaDetails,
      mediaDetailsId: item.mediaDetailsId === 0 ? null : item.mediaDetailsId,
    })),

    rotationSchemaDeveloperIds: [],
    rotationSchemaReferredBys: addRotationForm.rotationSchemaReferredBys,

    rotationSchemeProperties: addRotationForm.rotationSchemeProperties,
    rotationSchemaLeadsType: leadClasses.map((item) => ({
      leadClass: item.key,
    })),
    rotationSchemaMethodOfContacts:
      addRotationForm.rotationSchemaMethodOfContacts.map((item) => ({
        ...item,
        methodOfContactId: item.methodOfContactId,
      })),
    propertyCampaignIds: addRotationForm.rotationSchemeCampaigns.map(
      (item) => item.propertyCampaignId
    ),
    rotationSchemeTeams: schemaSettingsForm.rotationSchemeTeams,
    rotationSchemeBranches: schemaSettingsForm.rotationSchemeBranches,
    sla: schemaSettingsForm.sla,
    isActive: addRotationForm.isActive,
    isBulk: addRotationForm.isBulk,
    rotationSchemeLeadDistributionType:
      schemaSettingsForm.rotationSchemeLeadDistributionType,
    isOverrideLeadCapacitySettingEnabled:
      schemaSettingsForm.isOverrideLeadCapacitySettingEnabled === "true",
    rotationSchemeCourses: schemaSettingsForm.rotationSchemeCourses.map(
      (course) => ({
        ...course,
        scoreFrom: course.scoreFrom || 0,
        scoreTo: course.scoreTo || 100,
      })
    ),
  };
};

export const buildGetRotationQueryBody = (schemaData, schema) => {
  return {
    rotationSchemeId: schemaData.rotationSchemeId,
    label: schema.label,
    order: schema.order,
    rotationPreferredLanguages: schemaData.languages.map((item) => ({
      languageId: item.lookupsId,
      languageName: item.lookupItemName,
    })),
    rotationSchemeCountries: schemaData.countries.map((item) => ({
      countryId: item.lookupsId,
      countryName: item.lookupItemName,
    })),
    rotationSchemeCities: schemaData.cities.map((item) => ({
      cityId: item.lookupsId,
      cityName: item.lookupItemName,
    })),
    rotationSchemeCommunities: schemaData.communities.map((item) => ({
      communityId: item.lookupsId,
      communityName: item.lookupItemName,
    })),
    rotationSchemeDistricts: schemaData.districts.map((item) => ({
      districtId: item.lookupsId,
      districtName: item.lookupItemName,
    })),
    rotationSchemeSubCommunities: schemaData.subCommunities.map((item) => ({
      subCommunityId: item.lookupsId,
      subCommunityName: item.lookupItemName,
    })),
    rotationSchemeUnitTypes: schemaData.unitTypes.map((item) => ({
      unitTypeId: item.lookupsId,
      unitTypeName: item.lookupItemName,
    })),
    rotationSchemeRanges: schema.rotationSchemeRanges,
    rotationSchemaLeadsType: schemaData.leadsType,
    rotationSchemaContactCLasses: schema.leadClasses.map((item) => ({
      contactClassId: item.lookupsId,
      contactClassName: item.lookupItemName,
    })),
    rotationSchemeMedias: schema.medias.map((item) => ({
      mediaName: item.mediaName,
      mediaNameId: item.mediaId === 0 ? null : item.mediaId,
      mediaDetailsName: item.mediaDetails,
      mediaDetailsId: item.mediaDetailsId === 0 ? null : item.mediaDetailsId,
    })),
    rotationSchemaDeveloperIds: schemaData.developers.map((item) => ({
      developerName: item.developerName,
      developerId: item.developerId,
    })),
    rotationSchemaReferredBys: schema.referredBys,
    rotationSchemeProperties: schema.properties,
    rotationSchemaMethodOfContacts: schema.methodOfContact,
    propertyCampaignIds: schema.rotationSchemeCampaigns.map(
      (item) => item.propertyCampaignId
    ),
    isActive: schemaData.isActive,
    isBulk: schemaData.isBulk,
    rotationSchemeLeadDistributionType:
      schemaData.rotationSchemeLeadDistributionType,
    isOverrideLeadCapacitySettingEnabled:
      schemaData.isOverrideLeadCapacitySettingEnabled,
    sla: schema.sla,
    rotationSchemeTeams: schemaData.rotationSchemeTeams,
    rotationSchemeBranches: schemaData.rotationSchemeBranches,
  };
};

export const optionalFieldNames = {
  developer: ["developer"],
  unitType: ["rotationSchemeUnitTypes"],
  priceRange: ["priceRange"],
  size: ["size"],
  bedrooms: ["bedrooms"],
  mediaDetails: ["rotationSchemeMedias"],
  leadCampaign: ["propertyCampaignIds"],
  methodOfContact: ["rotationSchemaMethodOfContacts"],
  preferredLanguage: ["rotationPreferredLanguages"],
  location: [
    "rotationSchemeCountries,rotationSchemeCities",
    "rotationSchemeDistricts",
    "rotationSchemeCommunities",
    "rotationSchemeSubCommunities,rotationSchemeProperties",
  ],
  bathrooms: ["bathrooms"],
};
